import _axios from '../../apiClient'

export function GetResumen(payload) {
  return _axios.get(`/api/Pedido/GetResumenCatalogo`,
  {
    params:payload,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}

export function GetResumenByFilterTemporal(payload) {
  return _axios.post(`/api/Pedido/GetResumenByFilterTemporal`,
  payload,
  {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}

export function GetCarritosAbandonados(payload) {
  return _axios.get(`/api/Pedido/GetCarritosAbandonados`,
  {
    params:payload,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}

export function DeleteCarrito(payload) {
  return _axios.post(`/api/Pedido/BorrarCarrito`,
  payload
  ,{
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}

export function getPedidos(payload) {
  return _axios.get(`/api/Pedido/FindPedidos`,
  {
    params: payload,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}

export function getPedido(id) {
  return _axios.get(`/api/Pedido/GetPedido`,
  {
    params: {id},
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}
export function revertirPedido(id) {
  return _axios.get(`/api/Pedido/RevertirPedido`,
  {
    params: {id},
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}
export function entregarPedido(id) {
  return _axios.get(`/api/Pedido/EntregarPedido`,
  {
    params: {id},
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}
export function prepararPedido(id) {
  return _axios.get(`/api/Pedido/PrepararPedido`,
  {
    params: {id},
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}
export function prepararItemPedido(id, revertir) {
  return _axios.get(`/api/Pedido/PrepararItemPedido`,
  {
    params: {id, revertir},
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}

export function prepararItemPedidoGenerico(id, revertir) {
  return _axios.get(`/api/Pedido/PrepararItemPedidoGenerico`,
  {
    params: {id, revertir},
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}



export function marcarNoDisponibleItemPedidoGenerico(id, revertir) {
  return _axios.get(`/api/Pedido/MarcarItemNoDisponiblePedidoGenerico`,
  {
    params: {id, revertir},
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
	  })
	  .then(response => response.data)
	  .catch((error) => {
	    const data = error.response.data
	    throw (data)
	  })
  }
  
	export function getSugerenciasReemplazo(payload){
    return _axios.get(`/api/Pedido/GetSugerenciasReemplazo`,
    {
      params: payload,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
  }

  export function caratulaPedido(id) {
    return _axios.get(`/api/Pedido/Caratula`,
    {  responseType: 'blob', 
      params: {id}
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
  }

export function remitoPedido(id) {
  return _axios.get(`/api/Pedido/Remito`,
  {  responseType: 'blob', 
    params: {id}
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}
export function getEstadosPedido(payload) {
  return _axios.get(`/api/Pedido/GetEstadosPedido`,
  {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}

export function getFormasEntrega(payload) {
  return _axios.get(`/api/Pedido/GetFormasEntrega`,
  {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}

export function getMotivosEliminacion() {
  return _axios.get(`/api/Pedido/GetMotivosEliminacion`,
  {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}


export function getImagen(id) {
  return _axios.get(`/api/Pedido/Imagen`,
  {
    params: {id},
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}

export function saveNuevaCantidadPedidoDetalle(payload) {
  return _axios.post(`/api/Pedido/SaveNuevaCantidadPedidoDetalle`,
  payload,
  {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}

export function quitarPedidoDetalleReemplazo(payload) {
  return _axios.post(`/api/Pedido/QuitarPedidoDetalleReemplazo`,
  payload,
  {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}

export function saveNuevoPedidoDetalleReemplazo(payload) {
  return _axios.post(`/api/Pedido/SaveNuevoPedidoDetalleReemplazo`,
  payload,
  {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}

export function setTotalAPagar(payload) {
  return _axios.post(`/api/Pedido/SetTotalAPagar`,
  payload,
  {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}

export function changeTurnoPedido(payload) {
  return _axios.post(`/api/Pedido/ChangeTurnoPedido`,
  payload,
  {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}

export function georreferenciarDomicilio(payload) {
  return _axios.post(`/api/Pedido/GeorreferenciarDomicilio`,
  payload,
  {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}

export function getUltimaActualizacion(payload) {
  return _axios.get(`/api/Pedido/GetUltimaActualizacion`,
  {
    params: payload,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}

export function getCalendarioPedidos(payload) {
  return _axios.get(`/api/Pedido/GetCalendarioPedidos`,
  {
    params: payload,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => {
    return response.data
  })
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}